var map = {
	"./chat.ts": "c534",
	"./orderHistory.ts": "97a3",
	"./place.ts": "9c25",
	"./promotion.ts": "07b9",
	"./sockets.ts": "20df",
	"./takeAway.ts": "b754",
	"./timer.ts": "a961",
	"./user.ts": "21d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2299";